export default "__VITE_ASSET__dc7b1ba9__"